import React from 'react';
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {FooterContainerBox} from "./boxes/footer-container.box";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {AmountComponent} from "./parts/amount.component";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {GameFooterBarComponent} from "../../../../game-footer-bar.component";
import {JackpotBarMagicBallComponent} from '../../../../../jackpot-bar-magic-ball/jackpot-bar-magic-ball.component';

export const SpainGamePlayPcFooterBarComponent = observer(
    class SpainGamePlayPcFooterBarComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        
        private shouldRenderIGCMagic8Ball = () => {
            // If jackpot bet is enabled then the magic ball button will be rendered in game-jackpot-bar.component
            if (this.services.jackpotBet.isEnabled && this.props.gameContext.gameInfo.hasJackpotBet) {
                return false;
            }
            return this.services.magic8ball.shouldRenderBall;
        };

        private _renderBottomSection = () => {
            if (!this.shouldRenderIGCMagic8Ball()) {
                return null;
            }
            return <FooterContainerBox>
                <div style={{padding: "0.5rem"}}>
                    <JackpotBarMagicBallComponent />
                </div>
            </FooterContainerBox>
        }

        private _renderTopSection = () => {
            const gameSessionData = this.props.gameContext.gameSessionData;
            return (
                <FooterContainerBox>
                    <AmountComponent label={this.services.translation.translate('TOTAL_WINS')} amount={gameSessionData.totalWins}/>
                    <BlankHorizontalSeparatorBox multiplier={2}/>
                    <AmountComponent label={this.services.translation.translate('TOTAL_BETS')} amount={gameSessionData.totalBets}/>
                    <BlankHorizontalSeparatorBox multiplier={2}/>
                    <AmountComponent label={this.services.translation.translate('GAME_SESSION_BALANCE')} amount={gameSessionData.totalWins - gameSessionData.totalBets}/>
                </FooterContainerBox>
            );
        }
        render() {
            return (
                <GameFooterBarComponent gameContext={this.props.gameContext} renderTopSection={this._renderTopSection} renderBottomSection={this._renderBottomSection}/>
            )
        }
    }
);